<template>
  <div class="suspended-shell">
    <div class="suspended-card">
      <div class="suspended-icon">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
        </svg>
      </div>
      <h1 class="suspended-title">Obra suspensa</h1>
      <p class="suspended-desc">
        O acesso a esta obra está temporariamente suspenso.<br />
        Entre em contato com o administrador para mais informações.
      </p>
      <button class="btn-back" type="button" @click="goHome">Voltar para a página inicial</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SuspendedView',
  setup() {
    const router = useRouter()
    const goHome = () => router.push('/')
    return { goHome }
  }
})
</script>

<style scoped lang="scss">
.suspended-shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f5f2ee;
}

.suspended-card {
  max-width: 440px;
  width: 90%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(31, 30, 26, 0.1);
  padding: 48px 40px;
  text-align: center;
  display: grid;
  gap: 20px;
  justify-items: center;
}

.suspended-icon {
  color: #bf2b2b;
  opacity: 0.85;
}

.suspended-title {
  margin: 0;
  font-size: 26px;
  font-weight: 800;
  color: #1f1e1a;
}

.suspended-desc {
  margin: 0;
  font-size: 15px;
  color: #5a5752;
  line-height: 1.6;
}

.btn-back {
  margin-top: 8px;
  padding: 12px 28px;
  background: #1f1e1a;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover { opacity: 0.85; }
}
</style>
